import { call, put, select } from 'redux-saga/effects';

import { setInvoices } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getInvoices() {
  const organizationId = yield select((state) => state.organization.uuid);

  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/billing/invoices`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });

    if (success && !error) {
      // fixed:  https://jira.dolby.net/jira/browse/DLBIO-899
      yield put(setInvoices(result));
    }
  } catch (e) {
    console.error(e);
  }
}
